// ABOUTME: What the reveal cloud says for a stored storm: the heading and the text, from the storm alone.
// ABOUTME: Never reads the weather, so the reveal is the same on a first pass as after 2D.

import type { CrossingStormDto } from '../../../../types/api';
import { NO_STORM, NO_STORM_REVEAL_TEXT } from './noStorm';

export interface RevealCopy {
  heading: string;
  text: string;
}

export function revealFor(storm: CrossingStormDto | undefined): RevealCopy | undefined {
  if (!storm) return undefined;
  if (storm.code === NO_STORM) return { heading: 'What Was Hard to Notice', text: NO_STORM_REVEAL_TEXT };
  return { heading: 'What Felt True', text: storm.rule ?? '' };
}
